<template>
  <div>
    <!--供应商对账-->
    <header class="form-title">
      <Row>
        <Col span="24">
          <Form inline :label-width="100">
            <FormItem label="当前客户：" style="margin-right: 30px">
              <strong>{{selectCustomer.name}}</strong>
            </FormItem>
            <FormItem label="单据类型：" style="margin-right: 30px">
              <Select style="width: 200px" placeholder="全部单据" v-model="dbListFormData.state">
                <Option value>全部单据</Option>
                <Option value="0">非欠款单据</Option>
                <Option value="1">欠款单据</Option>
                <Option value="2">收款单据</Option>
              </Select>
            </FormItem>
            <FormItem label="选择时间：" style="margin-right: 30px">
              <DatePicker
                split-panels
                type="daterange"
                :options="options"
                placeholder="选择日期"
                @on-change="handleOk"
                :value="date"
              ></DatePicker>
            </FormItem>
            <FormItem label="总欠款：" style="margin-right: 30px">
              <div>
                <strong class="result">￥{{0-selectCustomer.money}}</strong>
                <Button
                  type="warning"
                  @click="payMoneyModal=true"
                  style="position: relative;top: 0px;left: 20px"
                >收款</Button>
              </div>
            </FormItem>
          </Form>
        </Col>
      </Row>
    </header>
    <Row style="margin: 0px 0 20px">
      <Col span="5" offset="5">
        交易金额:
        <strong class="result">￥{{sumDebt.shouldmoney}}</strong>
      </Col>
      <Col span="5">
        实收金额:
        <strong class="result">￥{{sumDebt.truemoney}}</strong>
      </Col>
      <Col span="5">
        应收余额:
        <strong class="result">￥{{sumDebt.surplusbalance}}</strong>
      </Col>
    </Row>
    <!-- 表格 -->
    <Table stripe :columns="columns" :data="dbList" :loading="loadingTable">

      <template slot-scope="{ row, index }" slot="shouldmoney"> 
        <span v-if="row.stateName=='付款单'">----</span>
        <span v-else>{{row.shouldmoney}}</span>
      </template>
     <template slot-scope="{ row, index }" slot="surplusbalance"> 
        <span v-if="row.stateName=='付款单'">----</span>
        <span v-else>{{row.surplusbalance}}</span>
      </template>

      <template slot-scope="{ row, index }" slot="action">
           <Button type="primary" size="small" @click="goDetail(row)">详情</Button>
      </template>
    </Table>
    <!-- 分页 -->
    <div class="pageTotal">
      <Page :total="page.total" :page-size="page.rows" show-total @on-change="onChangePage" />
    </div>
    <!--付款-->
    <Modal v-model="payMoneyModal" title="客户结算">
      <Form :label-width="100" inline>
        <FormItem label="客户：" class="payMoneyModal-input">
          <strong>{{selectCustomer.name}}</strong>
        </FormItem>
        <FormItem label="客户欠款：" class="payMoneyModal-input">
          <strong>{{0-selectCustomer.money}}</strong>
        </FormItem>
        <FormItem label="结算类型：" class="payMoneyModal-input">
          <strong>销售收入</strong>
        </FormItem>
        <FormItem label="业务时间：" class="payMoneyModal-input">
          <strong>{{today}}</strong>
        </FormItem>
        <FormItem label="结算账户：">
          <Select style="width: 300px" v-model="selectBank">
            <Option
              v-for="(item,index) in bankList"
              v-if="!item.bankname.includes('会员')"
              :value="item"
              :key="index"
              placeholder="请选择"
            >{{item.bankname}}</Option>
          </Select>
        </FormItem>
        <FormItem label="本次付款：">
          <Input-number :min="1" v-model="addFormData.truemoney" style="width: 300px"></Input-number>
        </FormItem>
        <FormItem label="备注：">
          <Input type="textarea" v-model="addFormData.remark" style="width: 300px"></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="payMoneyModal=false">取消</Button>
        <Button type="primary" @click="payOk()">确认</Button>
      </div>
    </Modal>
    <!--详情-->
        <Modal
                v-model="detailModal"
                width="800"
                title="客户结算详情">
            <Form :label-width="100" inline>
                <FormItem label="客户："  class="payMoneyModal-input" >
                    <strong>{{selectCustomer.name}}</strong>
                </FormItem>
                <FormItem label="门店："  class="payMoneyModal-input" >
                    <strong>{{doorShip}}</strong>
                </FormItem>
                <FormItem  label="操作人："  class="payMoneyModal-input">
                    <strong>{{detailModalData.adminname}}</strong>
                </FormItem>
                <FormItem  label="总欠款："  class="payMoneyModal-input">
                    <strong >{{0-selectCustomer.money+detailModalData.truemoney}}</strong>
                </FormItem>
                <FormItem  label="本次付款："  class="payMoneyModal-input">
                    <strong>{{detailModalData.truemoney}}</strong>
                </FormItem>
                <FormItem  label="尚欠款："  class="payMoneyModal-input">
                    <strong v-if="detailModalData.surplusbalance>0">-{{ detailModalData.surplusbalance}}</strong>
                    <strong v-else>{{0- detailModalData.surplusbalance}}</strong>
                </FormItem>
                <FormItem  label="结算账户："  class="payMoneyModal-input">
                <strong>{{detailModalData.bankName}}</strong>
            </FormItem>
                <FormItem  label="业务时间："  >
                    <strong>{{detailModalData.time}}</strong>
                </FormItem>

                <FormItem  label="单号："  >
                    <strong>{{detailModalData.code}}</strong>
                </FormItem>
                <FormItem  label="备注："  style=" display: block">
                    <strong>{{detailModalData.remark}}</strong>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button  @click="detailModal=false">取消</Button>
            </div>
        </Modal>
  </div>
</template>
<script>
import { Exp } from "@/util/Exp";
export default {
  name: "customerAnalysis",
  data() {
    return {
      cid: "",
      sid: "",
      debtFormData: {
        customerid: "",
        cid: "",
        sid: "",
        status: 2,
        time: Exp.getDays(-7),
        endtime: Exp.getDays(0)
      },
      dbListFormData: {
        page: 1,
        rows: 10,
        customerid: "",
        cid: "",
        sid: "",
        status: 2,
        state: "",
        time: Exp.getDays(-7),
        endtime: Exp.getDays(0)
      },
      bankFormData: {
        cid: "",
        sid: "",
        page: 1,
        rows: 1000
      },
      addFormData: {
        cid: "",
        sid: "",
        bankid: "",
        customerid: "",
        tradetypeid: "1",
        status: "2",
        truemoney: 1,
        surplusbalance: 1,
        adminid: JSON.parse(localStorage.getItem("adminUser")).id,
        remark: ""
      },
      bankList: [],
      tradetypeList: [],
      dbList: [],
      sumDebt: {
        shouldmoney: 0,
        truemoney: 0,
        surplusbalance: 0
      },
      loadingTable: false,
      options: {
        shortcuts: [
          {
            text: "昨日",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              return [start, start];
            }
          },
          {
            text: "今日",
            value() {
              const end = new Date();
              const start = new Date();
              return [start, end];
            }
          },
          {
            text: "近七日",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              return [start, end];
            }
          }
        ]
      },
      columns: [
        { title: "表单类型", key: "statusName", align: "center" },
        { title: "单据类型", key: "stateName", align: "center" },
        { title: "操作人", key: "adminname", align: "center" },
        { title: "时间", key: "time", align: "center" },
        { title: "单号", key: "code", align: "center", width: "220" },
        { title: "应收金额", key: "shouldmoney", align: "center",slot:'shouldmoney' },
        { title: "实收金额", key: "truemoney", align: "center" },
        { title: "应收余额", key: "surplusbalance", align: "center",slot:'surplusbalance' },
        { title: "操作", key: "edit", align: "center", slot: "action" }
      ],
      date: [Exp.getDays(-7), Exp.getDays(0)],
      selectCustomer: {},
      today: Exp.getDays(0),
      page: {
        total: 0,
        rows: 10
      },
      payMoneyModal: false,
      selectBank: {},
      detailModal:false,
        detailModalData:{},
         doorShip:JSON.parse(localStorage.getItem('shop')).name,
    };
  },
  created() {
    //获取用户信息
    this.cid = JSON.parse(localStorage.getItem("shop")).cid;
    this.sid = JSON.parse(localStorage.getItem("shop")).id;
    this.bankFormData.cid = this.dbListFormData.cid = this.debtFormData.cid = this.addFormData.cid = this.cid;
    this.bankFormData.sid = this.dbListFormData.sid = this.debtFormData.sid = this.addFormData.sid = this.sid;
    this.dbListFormData.customerid = this.debtFormData.customerid = this.addFormData.customerid = this.$route.query.cusId;

    this.getCustomer();
    this.getBankList();
    this.getTradetypeList();
    this.getDebtList();
    this.getSumDebt();
  },
  methods: {
    //获取客户详情
    getCustomer() {
      this.$Api.getCustomer({ id: this.$route.query.cusId }).then(res => {
        this.selectCustomer = res.data;
      });
    },
    // 获取账户信息
    getBankList() {
      this.$Api.getBankList(this.bankFormData).then(res => {
        if (res.code == 200) {
          this.bankList = res.data;
        }
      });
    },
    // 结算类型
    getTradetypeList() {
      this.$Api.getTradetypeList().then(res => {
        if (res.code == 200) {
          this.tradetypeList = res.data;
        }
      });
    },
    // 供应商单据列表
    getDebtList() {
      this.loadingTable = true;
      this.$Api
        .getDebtList(this.dbListFormData)
        .then(res => {
          this.loadingTable = false;
          if (res.code == 200) {
            this.dbList = res.data;
            this.page.total = res.count;
          }
        })
        .catch(err => {
          this.loadingTable = false;
        });
    },
    // 供应商对账总金额
    getSumDebt() {
      this.$Api.getSumDebt(this.debtFormData).then(res => {
        if (res.code == 200) {
          if (res.data) {
            this.sumDebt = res.data;
          }
        }
      });
    },
    handleOk(date) {
      if (date.length) {
        this.debtFormData.time = this.dbListFormData.time = date[0];
        this.debtFormData.endtime = this.dbListFormData.endtime = date[1];
        this.getDebtList();
        this.getSumDebt();
      }
    },
    onChangePage(num) {
      this.dbListFormData.page = num;
      this.getDebtList();
    },
    payOk() {
      if (JSON.stringify(this.selectBank) == "{}") {
        this.$Message.error("请选择收款账户");
        return false;
      }
      this.addFormData.bankid = this.selectBank.id;
      this.addFormData.surplusbalance = this.addFormData.truemoney;
      this.$Api.addDebt(this.addFormData).then(res => {
        if (res.code == 200) {
          this.$Message.success("收款成功");
          this.getCustomer();
          this.getDebtList();
          this.getSumDebt();
        } else {
          this.$Message.error(res.msg);
        }
        this.payMoneyModal = false;
      });
    },
    goDetail(item){
        
      if(item.stateName=='付款单'){
          this.detailModal=true
          this.detailModalData = item
      }else {
          this.$router.push(
              {
                  path:'/reconciliationDetail',
                  query:{
                      id:item.ids
                  }
              })
      }
    }

  },
  watch: {
    "dbListFormData.state": {
      handler(val) {
        this.getDebtList();
      },
      deep: true
    }
  }
};
</script>
<style lang="scss" scoped>
.form-title {
  line-height: 54px;
  border-bottom: 1px solid #d9d9d9;
  margin-bottom: 20px;
}
</style>